// extracted by mini-css-extract-plugin
module.exports = {"wqggv32":"wqggv32","g1vk9xxb":"g1vk9xxb"};